import { OtherTheme, Theme } from '@api/api/earnings-insights';
import { ErrorBoundaryWrapper } from '@terminal/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { PosthogTrackingSource } from '@terminal/services/tracking/posthog/constants';

import { ThematicFocusCard } from './components/ThematicFocusCard';
import { isTheme } from './components/utils';
import styles from './ThematicFocus.module.scss';

interface ThematicFocusProps {
  themes: Theme[];
  otherThemes: OtherTheme[];
  title: string;
  source: PosthogTrackingSource;
  withPill?: boolean;
}

export const ThematicFocus = ({
  themes,
  otherThemes,
  title,
  source,
  withPill = false,
}: ThematicFocusProps) => {
  const allThemes = [...themes, ...otherThemes];
  const totalThemes = allThemes.length;

  return (
    <>
      <div className={styles.title}>{title}</div>
      <div className={styles.root}>
        <ErrorBoundaryWrapper>
          {allThemes.map((theme, index) => (
            <ThematicFocusCard
              key={isTheme(theme) ? theme.theme_id : theme.name}
              theme={theme}
              source={source}
              isLast={index === totalThemes - 1}
              withPill={withPill}
            />
          ))}
        </ErrorBoundaryWrapper>
      </div>
    </>
  );
};
